import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getAllOrganization, getOrganizationTree } from '@/pages/baseData/organization/api'
import { getLocalStorage, setLocalStorage } from '@/utils/tools'

const departmentListCacheKey = 'cache-department-list'
const departmentListCache = getLocalStorage(departmentListCacheKey)
const departmentTreeCacheKey = 'cache-department-tree'
const departmentTreeCache = getLocalStorage(departmentTreeCacheKey)

export const fetchGetDepartmentListAsync = createAsyncThunk(
  'department/fetchGetDepartmentListAsync',
  () =>
    axios
      .get(getAllOrganization(departmentListCache?.version))
      .then((response) => {
        const resp = response?.data
        if (resp === null) return []
        if (
          resp.data === null &&
          resp.version === departmentListCache?.version
        ) {
          return departmentListCache.data ?? []
        } else {
          setLocalStorage(departmentListCacheKey, resp)
          return resp.data ?? []
        }
      })
      .catch((err) => {
        throw Error('读取组织缓存失败')
      })
)

export const fetchGetDepartmentTreeAsync = createAsyncThunk(
  'department/fetchGetDepartmentTreeAsync',
  () =>
    axios
      .get(getOrganizationTree(departmentTreeCache?.version))
      .then((response) => {
        const resp = response?.data
        if (resp === null) return []
        if (
          resp.data === null &&
          resp.version === departmentTreeCache?.version
        ) {
          return departmentTreeCache.data ?? []
        } else {
          setLocalStorage(departmentTreeCacheKey, resp)
          return resp.data ?? []
        }
      })
      .catch((err) => {
        throw Error('读取组织缓存失败')
      })
)

const departmentSlice = createSlice({
  name: 'department',
  initialState: {
    departmentTree: [],
    departmentList: [],
  },
  reducers: {
    setDepartmentTree(state, action) {
      state.departmentTree = action.payload
    },
    setDepartmentList(state, action) {
      state.departmentList = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetDepartmentTreeAsync.pending, (state) => {
        state.departmentTree = []
      })
      .addCase(fetchGetDepartmentTreeAsync.fulfilled, (state, action) => {
        state.departmentTree = action.payload
      })
      .addCase(fetchGetDepartmentListAsync.pending, (state) => {
        state.departmentList = []
      })
      .addCase(fetchGetDepartmentListAsync.fulfilled, (state, action) => {
        state.departmentList = action.payload
      })
  },
})

export const { setDepartmentTree, setDepartmentList } = departmentSlice.actions
//获取所有部门树
export const getDepartmentTree = (state) => state.department.departmentTree

export default departmentSlice.reducer
